import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import GiftIcon from '@wix/da-ds/pkg/Icons/24x24/Gift';
import DSModal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import Flex from '@wix/da-ds/pkg/Flex';
import DeviantsListCard from '../../../../../../../../DeviantsList/DeviantsListCard';
import EmptyView from './EmptyView';
import s from './GiftExclusivePopup.scss';
const GiftExclusivePopup = ({ requestClose, onItemClick })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(DSModal, {
        isOpen: true,
        heading: t('popup.giftExclusive.heading'),
        className: s['root'],
        layoutClassName: s['layout-root'],
        contentClassName: s['content-root'],
        onRequestClose: requestClose,
        withScrollableContentWrapper: false
    }, /*#__PURE__*/ React.createElement("section", {
        className: s['content']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['intro']
    }, t('popup.giftExclusive.body'), /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "popup.giftExclusive.learnMore"
    }, /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: s['mode-switcher-button'],
        onClick: ()=>Url.to(URLS.HELP)
    }, "Learn More"))), /*#__PURE__*/ React.createElement(DeviantsListCard, {
        contentClassName: s['deviants-list'],
        onItemClick: onItemClick,
        emptyView: /*#__PURE__*/ React.createElement(EmptyView, null),
        itemSuffix: /*#__PURE__*/ React.createElement(TextButton, {
            size: "small",
            variant: "main"
        }, /*#__PURE__*/ React.createElement(Flex, {
            alignItems: "center",
            justifyContent: "center",
            gap: 2
        }, /*#__PURE__*/ React.createElement(GiftIcon, {
            className: s['gift-icon'],
            disableDefaultColors: true
        }), t('popup.giftExclusive.button.giftExclusive'))),
        showSuffixOnlyOnHover: true
    })));
};
GiftExclusivePopup.displayName = 'GiftExclusivePopup';
export default GiftExclusivePopup;
